if (!customElements.get('cart-drawer-recommendations')) {
  customElements.define(
    'cart-drawer-recommendations',
    class CartDrawerRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true' || !this.dataset.url) return;
        this.dataset.loaded = 'true';

        fetch(this.dataset.url)
          .then((response) => {
            if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);
            return response.text();
          })
          .then((html) => {
            const documentFragment = new DOMParser().parseFromString(html, 'text/html');
            const content = documentFragment.querySelector('[data-cart-drawer-recommendations-content]');
            const ready = content && content.querySelector('[data-recommendations-ready]');

            if (!ready) {
              this.hidden = true;
              return;
            }

            this.innerHTML = content.innerHTML;
            this.hidden = false;
          })
          .catch(() => {
            this.hidden = true;
          });
      }
    }
  );
}
